import React from 'react';
const IconActionPin = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9201 0.809998L10.9401 7.2L5.73006 7.66L4.06006 9.33L14.6701 19.94L16.3401 18.27L16.8001 13.06L23.1901 10.08L13.9201 0.809998ZM14.9001 11.73L14.4501 16.89L7.11006 9.55L12.2701 9.1L14.5301 4.25L19.7501 9.47L14.9001 11.73Z" fill="#2D2E2E"/>
<path d="M7.56647 15.0136L2.2915 20.2886L3.7057 21.7028L8.98067 16.4278L7.56647 15.0136Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionPin;